export function getLast4Digits(n) {
  const lastDigits = `${n}`.substr(n.length-4, 4);
  return lastDigits;
}

export function getICLastDigits(n) {
  const newStr = new Array(`${n}`.length-3).join('*') + getLast4Digits(`${n}`);
    return newStr;
}

export function getICGender(n) {
  const lastDigit = n % 10;
  //Even
  if ( lastDigit % 2 === 0) {
    return 'Female';
  }
  //Odd
  if (Math.abs(lastDigit % 2) === 1 ) {
    return 'Male';
  }
  return 'Undefined';
}

export function getICBirthdate(nric) {
  const yymmdd = `${nric}`.substring(0, 6);

  let year = yymmdd.substring(0, 2) - 0;
  const month = yymmdd.substring(2, 4) - 1;
  const day = yymmdd.substring(4, 6) - 0;

  if (year < `${(new Date()).getFullYear()}`.substring(2, 4)) {
    year += 2000;
  } else {
    year += 1900;
  }

  const fullDateTime = `${new Date(year, month, day)}`;
  const fullDate = fullDateTime.split(" ").slice(0, 4).join(" ");

  return fullDate;
}



// WEBPACK FOOTER //
// ./src/utils/format.js